import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  appUtils, Button, Select, toast
} from 'src/components/';
import { GoalsContext } from 'src/containers/Goals/context/GoalsProvider';
import { exportGoalsQuery } from 'src/containers/Goals/queries';

const GoalsActions = () => {
  const navigate = useNavigate();
  const loggedUserId = appUtils.getLoggedUserId();
  const { context } = useContext(GoalsContext);
  const { mutateAsync: exportData } = exportGoalsQuery();
  const actionOptions = [{ id: 'excel', label: 'Export' }];

  const exportFn = async () => {
    const res = await exportData({
      filename: 'Goals',
      filters: { ...context }
    });
    toast.show('Export successful');
  };
  const isSuperUser = appUtils.isSuperUser();

  return (
    <div className='flex flex-col-reverse lg:flex-row gap-2 text-black self-end mb-2'>
      <Select
        id='goals-actions-actions-filter'
        title='Actions'
        classes='w-36'
        variant='shadow'
        onChange={() => {
          exportFn();
        }}
        options={actionOptions}
      />
      <Button
        variant='black'
        classes='px-10 py-1 whitespace-nowrap h-[39.5px]'
        onClick={() => navigate(`/dashboard/goal/new/${loggedUserId}?redir=/dashboard/goals`)}
      >
        Create Goal
      </Button>
      {isSuperUser ? (
        <Button
          variant='black'
          classes='px-10 py-1 whitespace-nowrap h-[39.5px]'
          onClick={() => navigate('/dashboard/goals/upload')}
        >
          Upload Goals (superuser)
        </Button>
      ) : null}
    </div>
  );
};

export default GoalsActions;
